import { render, staticRenderFns } from "./AchievementEditorTab.vue?vue&type=template&id=dcd86b80&scoped=true&"
import script from "./AchievementEditorTab.vue?vue&type=script&lang=js&"
export * from "./AchievementEditorTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd86b80",
  null
  
)

export default component.exports